import { render, staticRenderFns } from "./Magazine.vue?vue&type=template&id=3a51e34e&scoped=true"
import script from "./Magazine.vue?vue&type=script&lang=js"
export * from "./Magazine.vue?vue&type=script&lang=js"
import style0 from "./Magazine.vue?vue&type=style&index=0&id=3a51e34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a51e34e",
  null
  
)

export default component.exports